import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ValidatorsService } from '@services/validators.service';
import { Observable, map, startWith } from 'rxjs';

@Component({
  selector: 'app-display-errors',
  templateUrl: './display-errors.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DisplayErrorsComponent implements OnInit {
  @Input() control!: AbstractControl;
  private readonly validatorService = inject(ValidatorsService);

  protected errors$!: Observable<string[]>;

  ngOnInit() {
    if (!this.control) return;
    const control = this.control;
    this.errors$ = control.statusChanges.pipe(
      startWith(control.status),
      map(status => {
        if (status !== 'INVALID') return [];
        const errors: string[] = [];
        const { errorMessages } = this.validatorService;
        for (const key in control.errors) {
          if (!errorMessages[key]) continue;
          errors.push(errorMessages[key]);
          break;
        }
        return errors;
      })
    );
  }
}
